import type { JSX } from "react";
import {
  Calendar,
  CalendarFill,
  SofaV2,
  SofaV2Fill,
  UsersV3,
  UsersFill,
  Heart,
  HeartFill,
  Menu3,
} from "@repo/icons";
import { Link, type LinkProps, useSearch } from "@tanstack/react-router";

interface BarOptionsV2Props {
  url: LinkProps["to"];
  search?: LinkProps["search"];
  Icon: React.ElementType;
  SelectedIcon: React.ElementType;
  title: string;
}

interface SearchParams {
  date?: string;
  locationId?: number;
}

export const BottomBarV2 = (): JSX.Element => {
  const searchParams: SearchParams = useSearch({ strict: false });

  const barOptions: Record<string, BarOptionsV2Props> = {
    home: {
      Icon: Heart,
      SelectedIcon: HeartFill,
      url: "/home",
      title: "Para você",
    },
    calendar: {
      Icon: Calendar,
      SelectedIcon: CalendarFill,
      url: "/calendar",
      title: "Agenda",
      search: { date: searchParams.date, locationId: searchParams.locationId },
    },
    waitingRoom: {
      Icon: SofaV2,
      SelectedIcon: SofaV2Fill,
      url: "/waiting-room",
      title: "Espera",
    },
    patient: {
      Icon: UsersV3,
      SelectedIcon: UsersFill,
      url: "/patients",
      title: "Pacientes",
    },
    menu: {
      Icon: Menu3,
      SelectedIcon: Menu3,
      url: "/settings",
      title: "Menu",
    },
  };

  return (
    <div id="bottom-bar-v2" className="z-20 fixed w-full bottom-0">
      <nav className="flex flex-row py-2 w-full bg-white justify-evenly px-1 border-t-[1.5px] border-neutral-100">
        <div className="flex w-full items-center justify-center">
          {Object.entries(barOptions).map(([key, option]) => (
            <Link
              aria-label={`Botão ${key}`}
              key={key}
              to={option.url}
              search={option.search}
              className="flex w-full justify-center"
              preload={false}
              activeOptions={{ includeSearch: false }}
            >
              {({ isActive }: { isActive: boolean }) => {
                const Icon = isActive ? option.SelectedIcon : option.Icon;
                const color = isActive ? "secondary" : "neutral";

                return (
                  <div className="flex flex-col items-center">
                    <Icon className={`fill-${color}-400`} size={24} />
                    <span className={`text-xs text-${color}-400 truncate`}>
                      {option.title}
                    </span>
                  </div>
                );
              }}
            </Link>
          ))}
        </div>
      </nav>
    </div>
  );
};
